import React from 'react'
import post from '../images/post.svg'
import { Link } from 'react-router-dom'
const Landing = () => {
  return (
    <div className='landing'>
        <div class="lContainer">
            <h1 className='landingTitle'>CollegeConnect.</h1>
                <div>
                    <h3>Type your Institutions Name to Get Started</h3>
                    <input placeHolder="e.g Binghamton Universtiy" type="text"></input>
                    <Link to='dash'><button>Enter</button></Link>
                </div>
        </div>
        <img src={post} alt=""/>
    </div>
  )
}

export default Landing